module.exports = __webpack_public_path__ + "static/img/Servimos_Zanahoria.4055cbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icons/Servimos_Zanahoria.png
// module id = 58
// module chunks = 0